import * as _ from 'lodash';
import { Component, ViewChild, Input, NgZone, ElementRef } from '@angular/core';
import { AgmMap, MapsAPILoader, LatLngBounds } from '@agm/core';
import { CargoTrackList, ShipmentShipLog, ShipLog, PortCallLog, ShipmentPortCall, PortcallIndexObject, PortCallList, ShedAddress } from '../../../../services/consults.service';
import { Util } from '../../../../utils'
import * as moment from 'moment';
import { ConsultRequestService, AlertService, CnsltnQuotRouteModel, GmapLogService } from '../../../../services/index';
import DateTimeUtil from '../../../../utils/datatime';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject, BehaviorSubject, Observable } from 'rxjs';

declare var google:any;

@Component({
  selector: 'tracking-new',
  templateUrl: 'tracking-new.html',
  styles: [`
    agm-map {
      height: 550px;
      width: 100%;
    }
  `],
  animations: [
    trigger('collapseChange', [
        state('false' ,
            style({ height: '0', overflow : 'hidden' }),
        ),
        state('true',
            style({ height: '*' })
        ),
        transition('* => *', animate('.2s ease-out'))
      ]),
      trigger('iconChange', [
          state('false',
              style({ transform: 'rotate( 0deg )' })
          ),
          state('true',
              style({ transform: 'rotate( -180deg )' })
          ),
          transition('* => *', animate('.2s'))
      ])
  ]
})
export class TrackingNewComponent {
  @Input('cnsltnReq') set reqNo(cnsltnReq) {
    this._reqNo = cnsltnReq.reqNo;
    this._cnsltnReq = cnsltnReq;
    if(this._reqNo) this.getShipmentSelected();
  }
  @ViewChild('AgmMap') agmMap: AgmMap;
  @ViewChild('shedModal') shedModal:ElementRef;
  @Input() quotRoutes: CnsltnQuotRouteModel[];

  dateSetter: Function = DateTimeUtil.dateSetter;
  timeSetter: Function = DateTimeUtil.timeSetter;
  dateTimeSetter: Function = DateTimeUtil.dateTimeSetter;
  getProgress: Function = DateTimeUtil.getProgress;
  getShipmentProgress: Function = DateTimeUtil.getShipmentProgress;


  _reqNo:string;
  _cnsltnReq;
  selectedShipment:CargoTrackList;

  shipmentShipLog: ShipmentShipLog[];
  selectedShipLog: ShipLog[];
  activeShipLog: ShipLog;

  selectedShipPortLog:PortCallLog[] = [];
  selectedShipPortLogNowIndex: number = -1;
  selectedShipLogOld:PortCallLog[] = [];
  selectedShipLogFuture:PortCallLog[] = [];
  selectedShipLogFutureIndex:number = -1;
  selectedShipmentPortLog: ShipmentPortCall[] = [];
  selectedShipmentPortLogNowIndex:PortcallIndexObject = {index : -1, index2: -1};


  tryTrack:number = 1;
  userTry:boolean = false;
  showOld:boolean = false;
  showFuture:boolean = false;
  showUnipass:boolean = false;
  
  map:any;
  marker;
  mapLat: number;
  mapLng: number;
  infoWindowOpen:boolean = false;

  zoom:number = 5;
  isSnazzyInfoWindowOpened:boolean = false; 

  line: Array<any> = [];

  selectetPortLogIndex: number = 0;
  selectedShipLogIndex: boolean[] = [];
  
  showShedInfo:boolean = false;
  shedInfo:ShedAddress[] = [];

  infoError:boolean = false;
  showUnipassDetail:boolean = false;

  mapReadyCheck:BehaviorSubject<boolean> = new BehaviorSubject(false);

  _mapReadyCheckObs: Observable<boolean>;

  mapReadyYOrNo:boolean = false;  

  constructor(private consultRequestService:ConsultRequestService, private mapsApiLoader:MapsAPILoader, private ngZone:NgZone, private alertService:AlertService, private gmapLogService: GmapLogService) {
    this.mapReadyCheck = new BehaviorSubject(false);
    this._mapReadyCheckObs = this.mapReadyCheck.asObservable();

    this._mapReadyCheckObs.subscribe(yOrN => {
      this.mapReadyYOrNo = yOrN;
      if(yOrN && this.selectedShipment && this.selectedShipment.vesselInfoList) {
        this.mapFitBounds();
      } else if(yOrN && !this.selectedShipment && this.quotRoutes) {
        this.mapFitBounds2();
      }      
    })
  }

  mapReady(map) {
    this.map = map;
    this.gmapLogService.log('consult-detail', 'MAP' );
    this.mapReadyCheck.next(true);
  }

  mapFitBounds() {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const mm of this.selectedShipment.vesselInfoList) {
      bounds.extend(new google.maps.LatLng(mm.depLocationInfo.latitude, mm.depLocationInfo.longitude));
      bounds.extend(new google.maps.LatLng(mm.arrLocationInfo.latitude, mm.arrLocationInfo.longitude));
    }

    for(const route of this.quotRoutes) {
      bounds.extend(new google.maps.LatLng(route.latitude,route.longitude));
    }
    
    
    this.map.fitBounds(bounds);
  }

  mapFitBounds2() {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for(const route of this.quotRoutes) {
      bounds.extend(new google.maps.LatLng(route.latitude,route.longitude));
    }
    this.map.fitBounds(bounds);
  }
  
  getShipmentSelected() {
    this.userTry = false;
    this.showUnipass = false;
  
    this.consultRequestService.getTrackingInfo(this._reqNo).subscribe(resp => {
      this.selectedShipment = resp.data;

      if(this.selectedShipment == null) this.infoError = true;

      if(!this.selectedShipment) return;

      if(this.selectedShipment.curVesselInfo) this.selectedShipment.curVesselInfo.progress = this.getProgress(this.selectedShipment.curVesselInfo);
      if(this.selectedShipment.vesselInfoList && this.mapReadyYOrNo) this.mapFitBounds();

      this.getShipmentShipLog();
      this.getShipmentPortCall();
    });
  }

  getShipmentShipLog() {
    this.consultRequestService.getTrackingLog(this._reqNo).subscribe(resp => {
        this.makeShipmentTrackList(resp.data);
      },
      error => {
        this.alertService.success("운항로그를 가져오지 못했습니다.");
      }
    );  
  }

  getShipmentPortCall() {
    this.consultRequestService.getTrackingPortcall(this._reqNo).subscribe(resp => {
        this.makeShipmentPortCallList(resp.data);
      },
      error => {
        this.selectedShipmentPortLog = [];
      });
      
  }


  makeShipmentTrackList(resp) {
    if(!resp || resp && resp.length == 0) {
      this.shipmentShipLog = [];
      this.activeShipLog = null;        
      return;
    };
    this.shipmentShipLog = resp;
    this.shipmentLineDraw(this.shipmentShipLog);
    
    for(let i = 0; i<this.shipmentShipLog.length; i++) {
      if(!_.isEmpty(this.shipmentShipLog[i].transLogList)) {
        this.activeShipLog = this.shipmentShipLog[i].transLogList[0];
        break;
      } else {
        this.activeShipLog = null;
      }
    }

    if(this.activeShipLog) {
      let randomCourse = Math.floor(Math.random() * (360 - 1)) + 1;
      if(this.selectedShipment && !this.selectedShipment.curVesselInfo) {
        this.markerLoad({navCode: this.selectedShipment.summaryInfo.cargoActionStatus, course: randomCourse, latitude: this.activeShipLog.latitude, longitude: this.activeShipLog.longitude});
      } else {
        this.markerLoad();
      }
    }  
  }

  makeShipmentPortCallList(resp) {
    this.selectedShipLogIndex = [];
    this.selectedShipmentPortLog = resp;
    
      if(this.selectedShipmentPortLog && this.selectedShipmentPortLog[0] != null) {
        //this.selectedShipmentPortLog.reverse();
        this.selectedShipmentPortLog.map(portlog => {
          if(portlog.portCallLogList) portlog.portCallLogList.reverse();
          this.selectedShipLogIndex.push(true);
        });
      
        for(let i = 0; i<this.selectedShipment.vesselInfoList.length; i++) {
          let vesselInfo = this.selectedShipment.vesselInfoList[i];
          let portCall:ShipmentPortCall = _.find(this.selectedShipmentPortLog, {'vesselNm': vesselInfo.vesselNm});

          if(vesselInfo.vesselNm != null) {
            if((vesselInfo.etd != null || vesselInfo.atd != null) && vesselInfo.depLocationInfo) {
              let depLocationId = _.find(portCall.portCallLogList, {'locationId' : vesselInfo.depLocationInfo.locationId});
              if(!depLocationId) {
                depLocationId = _.find(portCall.portCallLogList, log => {
                  return _.includes(log.groupLocationId, vesselInfo.depLocationInfo.locationId);
                });
              };

              if(!depLocationId) {
                let newPortcall: PortCallLog = new PortCallLog();
                
                newPortcall.etd = vesselInfo.etd;
                newPortcall.atd = vesselInfo.atd;
                newPortcall.locationCd = vesselInfo.depLocationInfo.locationCd;
                newPortcall.latitude = vesselInfo.depLocationInfo.latitude;
                newPortcall.locationId = vesselInfo.depLocationInfo.locationId;
                newPortcall.locationName = vesselInfo.depLocationInfo.name;
                newPortcall.longitude = vesselInfo.depLocationInfo.longitude;
                newPortcall.insert = true;

                if(portCall.portCallLogList == null) {
                  portCall.portCallLogList = [];
                  portCall.portCallLogList.push(newPortcall);
                } else {
                  let index = _.findIndex(portCall.portCallLogList, portcall => { 
                    let portcallTime = null;
                    if(portcall.atd != null && portcall.etd != null) {
                      portcallTime = (moment(portcall.atd).valueOf() > moment(portcall.etd).valueOf()) ? portcall.atd : portcall.etd;
                    } else if(portcall.atd != null && portcall.etd == null) {
                      portcallTime = portcall.atd;
                    } else if(portcall.atd == null && portcall.etd != null) {
                      portcallTime = portcall.etd;
                    } else {
                      portcallTime = null;
                    }
                    let vesselInfoTime = (moment(vesselInfo.atd).valueOf() > moment(vesselInfo.etd).valueOf()) ? vesselInfo.atd : vesselInfo.etd;
                    return moment(portcallTime).valueOf() > moment(vesselInfoTime).valueOf();
                  });
                  index = index-1;
                  if(index <= -1) {
                    index = 0;
                  }
                  portCall.portCallLogList.splice(index, 0, newPortcall);
                }

                //console.log(newPortcall);
              }
            }

            if((vesselInfo.eta != null || vesselInfo.ata != null) && vesselInfo.arrLocationInfo) {
              let arrLocationId = _.find(portCall.portCallLogList, {'locationId' : vesselInfo.arrLocationInfo.locationId});

              if(!arrLocationId) {
                arrLocationId = _.find(portCall.portCallLogList, log => {
                  return _.includes(log.groupLocationId, vesselInfo.arrLocationInfo.locationId);
                });
              };

              if(!arrLocationId) {
                let newPortcall: PortCallLog = new PortCallLog();
                newPortcall.eta = vesselInfo.eta;
                newPortcall.ata = vesselInfo.ata;
                newPortcall.locationCd = vesselInfo.arrLocationInfo.locationCd;
                newPortcall.latitude = vesselInfo.arrLocationInfo.latitude;
                newPortcall.locationId = vesselInfo.arrLocationInfo.locationId;
                newPortcall.locationName = vesselInfo.arrLocationInfo.name;
                newPortcall.longitude = vesselInfo.arrLocationInfo.longitude;
                newPortcall.insert = true;

                if(portCall.portCallLogList == null) {
                  portCall.portCallLogList = [];
                  portCall.portCallLogList.push(newPortcall);
                } else {
                  let index = _.findIndex(portCall.portCallLogList, portcall => { 
                  let portcallTime = null;
                    if(portcall.ata != null && portcall.eta != null) {
                      portcallTime = (moment(portcall.ata).valueOf() > moment(portcall.eta).valueOf()) ? portcall.ata : portcall.eta;
                    } else if(portcall.ata != null && portcall.eta == null) {
                      portcallTime = portcall.ata;
                    } else if(portcall.ata == null && portcall.eta != null) {
                      portcallTime = portcall.eta;
                    } else {
                      portcallTime = null;
                    }
                    let vesselInfoTime = (moment(vesselInfo.ata).valueOf() > moment(vesselInfo.eta).valueOf()) ? vesselInfo.ata : vesselInfo.eta;
                    return moment(portcallTime).valueOf() > moment(vesselInfoTime).valueOf();
                  });
                  if(index <= -1) {
                    index = portCall.portCallLogList.length;
                  };
                portCall.portCallLogList.splice(index, 0, newPortcall);
              }

              //console.log(newPortcall);
            }
          }
        }            
      }
       
      let lastPortLog = _.last(_.last(this.selectedShipmentPortLog).portCallLogList);
      let arriveTime = null;
      
      if(!_.isEmpty(lastPortLog)) {
        if(_.startsWith(lastPortLog.locationCd, 'KR')) {
          if(lastPortLog.ata) {
            arriveTime = moment(lastPortLog.ata);
          } else if(!lastPortLog.ata && lastPortLog.eta) {
            arriveTime = moment(lastPortLog.eta);
          } else {
            this.showUnipass = false;
          }

          if(arriveTime) {
            let diffTime = arriveTime.diff(moment(), 'hours');
            
            if(diffTime <= 24) {
              this.showUnipass = true;
            } else {
              this.showUnipass = false;
            }
          } else {
            this.showUnipass = false;
          }
          
        } else {
          this.showUnipass = false;
        }
      }

      this.selectetPortLogIndex = this.selectedShipmentPortLog.length-1;
      this.selectedShipmentPortLogNowIndex = this.getNowShipmentPortcallIndex(this.selectedShipmentPortLog);
    }
  }

  shipmentLineDraw(trackLog:ShipmentShipLog[]) {
    if(!this.map) {
      this.mapsApiLoader.load().then(() => {
        this.shipmentLineDrawActual(trackLog)
      });
    } else {
      this.shipmentLineDrawActual(trackLog);
    }
  }

  shipmentLineDrawActual(trackLog: ShipmentShipLog[]){
    
    this.ngZone.runOutsideAngular(() => {
      let logList:ShipmentShipLog[] = trackLog;

      var lineSymbol = {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
      };
      

      let notEmptyFirstIndex = _.findIndex(logList, log => { return !_.isEmpty(log.transLogList)});

      
      let color = null;
      let colorNum = null;
    
      for (let j =0; j <logList.length; j++) {
        //
        let trackList = _.uniqWith(
          logList[j].transLogList,
          (locationA, locationB) =>
            locationA.latitude === locationB.latitude &&
            locationA.longitude === locationB.longitude
        );
        let track = [];  

        
        for(let i = 0; i < trackList.length; i++) {
          if(i == 0) {
            track.push(trackList[i]);
          } else if(i == trackList.length-1) {
            track.push(trackList[i]);
          } else {
            var time = moment(_.last(track).received, 'YYYY-MM-DD HH:mm:ss').diff(moment(trackList[i].received, 'YYYY-MM-DD HH:mm:ss'), 'hours');     
            if(time > 2 || time == 2) {
              track.push(trackList[i]);
            }
          }
        };
        
        if(j > notEmptyFirstIndex && colorNum < 250) {
          colorNum = colorNum + 10;
        } else if(j == notEmptyFirstIndex + 1){
          colorNum = 150;
        } else {
          colorNum = 250;
        };  

        if(j == notEmptyFirstIndex) {
          color = '#198cff';
        } else {
          color = 'rgb(' + colorNum + ',' + colorNum + ',' + colorNum + ')'
        }  
      
        for(let l = track.length-1; l > -1; l--) {

          
          let color2 = null;
          if(track[l-1]) {
          

            if(l%10 == 0 || l == (track.length - 2)) {
              var line = new google.maps.Polyline({
                path: [{lat:track[l].latitude, lng: track[l].longitude}, {lat:track[l-1].latitude, lng: track[l-1].longitude}],
                icons: [{
                  icon: lineSymbol,
                  offset: '100%'
                }],
                geodesic: false,
                strokeColor: color2 != null ? color2 : color,
                strokeOpacity: 1.0,
                strokeWeight: 1.5,
                
              });
              this.line.push(line);
            } else {
              var line = new google.maps.Polyline({
                path: [{lat:track[l].latitude, lng: track[l].longitude}, {lat:track[l-1].latitude, lng: track[l-1].longitude}],
                geodesic: false,
                strokeColor: color2 != null ? color2 : color,
                strokeOpacity: 1.0,
                strokeWeight: 1.5,
              
              });
              this.line.push(line);
            }
          }          
        }
      }

      this.line.map(line => line.setMap(this.map));
    });
  }

  markerLoad(vessel?) {
    if(this.marker) {
      this.marker.setMap(null);
      this.marker = null;
    }

    if(!this.map) {
      this.agmMap.mapReady.subscribe(map => {
        this.map = map;
        this.iconMaker(vessel);
      });
    } else {
      this.iconMaker(vessel);
    }    
  }

  iconMaker(ship?) {
    let vessel = null;
    if(ship) {
      vessel = ship;
    } else {
      vessel = this.selectedShipment.curVesselInfo;
    }

    var color = '#d3d3d3';
    var strokeColor = '#9e9e9e';
    if(this.activeShipLog) {
      if (vessel['navCodeNm'] == '항해중' || (vessel['navCode'] != undefined && vessel['navCode'] != null && vessel['navCode'] == '항해중')) {
        color = '#679df4';
        strokeColor = '#1052f9';
      };  
    } else {
      if(this.activeShipLog.status == '항해중') {
        color = '#679df4';
        strokeColor = '#1052f9';
      }
    }
    
    let deg = null;
    if(vessel) {
      deg = vessel.course;
    }
    
    
    let icon = {
      path: 'M5.01,0.01V0C5.01,0,5,0.01,5.01,0.01C5,0.01,4.99,0,4.99,0v0.01C4.78,0.28,0,5.93,0,9.11l0.32,11.3C0.33,20.74,0.61,21,0.95,21h4.04h0.01h4.04c0.34,0,0.63-0.26,0.63-0.59L10,9.11C10,5.93,5.22,0.28,5.01,0.01z',
      fillColor: color,
      fillOpacity: 1,
      scale: 1,
      rotation: deg != null ? deg : Math.random() * (360 - 1) + 1,
      strokeWeight: 3,
      strokeColor: strokeColor,
      anchor: new google.maps.Point(5, 10),
    }

    if(this.activeShipLog.latitude && this.activeShipLog.longitude) {
      this.marker = new google.maps.Marker({
        position: { lat: Number(this.activeShipLog.latitude), lng: Number(this.activeShipLog.longitude) },
        icon: icon,
        map: this.map
      }); 
    }else if(this.selectedShipment.curVesselInfo && this.selectedShipment.curVesselInfo.latitude && this.selectedShipment.curVesselInfo.longitude){
      this.marker = new google.maps.Marker({
        position: { lat: Number(vessel.latitude), lng: Number(vessel.longitude) },
        icon: icon,
        map: this.map
      });
    } else {
      this.marker = new google.maps.Marker({
        position: { lat: Number(vessel.latitude), lng: Number(vessel.longitude) },
        icon: icon,
        map: this.map
      });
    }
    
    this.marker.addListener('click', () => {
      this.infoWindowOpen = true;
    });
  }

  getNowShipmentPortcallIndex(shipments: ShipmentPortCall[]) {
    let allPortcallLogs:PortCallList[] = [];
    for (let i = 0; i < shipments.length; i++) {
      if(!_.isEmpty(shipments[i].portCallLogList)) {
        shipments[i].portCallLogList.map(
          (portcall, j)=> {
            allPortcallLogs.push({index: i, index2: j, log: portcall});
        });
      }
    }

    if (!allPortcallLogs || allPortcallLogs.length <= 0) return null;
    let nowIndex = { index: -1, index2: -1 };
    let today: moment.Moment = moment();

    for (let i: number = allPortcallLogs.length-1; i > -1; i--) {
      let portcallLog = allPortcallLogs[i];
      if(portcallLog.log.ata || portcallLog.log.atd) {
        nowIndex = {index : portcallLog.index, index2: portcallLog.index2};
        break;
      } else {
        nowIndex = { index: -1, index2: -1 };
      }      
    }
    
    if(nowIndex.index == -1) {
      for (let i: number = allPortcallLogs.length-1; i > -1; i--) {
        let portcallLog = allPortcallLogs[i];
        let compareTime: moment.Moment = moment(portcallLog.log.ata || portcallLog.log.atd || portcallLog.log.eta || portcallLog.log.etd);
        let days = today.diff(compareTime, 'days');
        if (days > -1 && days < 1) {
        nowIndex = {index : portcallLog.index, index2: portcallLog.index2};
          break;
        } 
        else nowIndex = { index: -1, index2: -1 };
      }
    }

    if(nowIndex.index == -1) {
      for (let i: number = allPortcallLogs.length-1; i > -1; i--) {
        let portcallLog = allPortcallLogs[i];
        let compareTime: moment.Moment = moment(portcallLog.log.ata || portcallLog.log.atd || portcallLog.log.eta || portcallLog.log.etd);
        let days = today.diff(compareTime, 'days');
        if (days > -2 && days < 2) {
          nowIndex = {index : portcallLog.index, index2: portcallLog.index2};
          break;
        } 
        else nowIndex = { index: -1, index2: -1 };
      }
    }
    return nowIndex;
  }

  handleShowShedInfo(event) {
    this.showShedInfo = event;
  }

  shedInfoChanged(event) {
    this.shedInfo = event;
  }

  handleOutsideCloseShed(event:HTMLElement) {
    if(event != this.shedModal.nativeElement) this.showShedInfo = false; //&& !event.classList.contains('clickable')
  }


  shipmentPortcallClass(index: number, index2: number) {
    if (index === this.selectedShipmentPortLogNowIndex.index && index2 == this.selectedShipmentPortLogNowIndex.index2) return 'now-schedule';
    else if (index > this.selectedShipmentPortLogNowIndex.index || index === this.selectedShipmentPortLogNowIndex.index && index2 > this.selectedShipmentPortLogNowIndex.index2) return 'ing-schedule';
    else return 'old-schedule';
  }

  showOldPortCallLog() {
    this.showOld = !this.showOld;
    
  }

  showFuturePortCallLog() {
    this.showFuture = !this.showFuture;
    
  }

  isInfoWindowOpen(event:boolean) {
    this.infoWindowOpen = event;
    
  }

  handleSelectetPortLogIndex(index) {
    this.selectetPortLogIndex = index;
  }

  handleShipmentSelectetPortLogIndex(index) {
    if(this.selectedShipLogIndex == index) this.selectedShipLogIndex = null;
    else {
      this.selectedShipLogIndex = index;
      this.showUnipassDetail = false;
    }
  }

  getShipmentPortLogmarker(index: number, index2: number) {
    let url = '/images/marker/';
    if (index === this.selectedShipmentPortLogNowIndex.index && index2 == this.selectedShipmentPortLogNowIndex.index2) return url + 'now.svg';
    else if (index > this.selectedShipmentPortLogNowIndex.index || index === this.selectedShipmentPortLogNowIndex.index && index2 > this.selectedShipmentPortLogNowIndex.index2) return url + 'ing.svg';
    else return url + 'old.svg';
  }

  showUnipassChanged(event) {
    if(event === true) this.selectedShipLogIndex = null;
    this.showUnipassDetail = event;
  }





}



// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/tracking-new.ts